var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.067,
    height: 20.164,
    viewBox: "0 0 21.067 20.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star",
    "data-name": "Icon awesome-star",
    d: "M10.845.7,8.273,5.914,2.52,6.753a1.261,1.261,0,0,0-.7,2.15l4.162,4.056L5,18.688a1.259,1.259,0,0,0,1.827,1.327l5.147-2.705,5.147,2.705a1.26,1.26,0,0,0,1.827-1.327l-.984-5.729L22.126,8.9a1.261,1.261,0,0,0-.7-2.15l-5.753-.839L13.105.7a1.261,1.261,0,0,0-2.26,0Z",
    transform: "translate(-1.441 0.001)",
    fill: "#FFB71A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6e8ec1627b53a2a3cdf8353b0f320bf0.svg";
export { ForwardRef as ReactComponent };